/**
 * Created by markush on 9/14/16.
 */

export class Utils {

  public static toUrlString(obj: any): string {
    return Object.keys(obj).map(function (key) {
      return key + '=' + obj[key];
    }).join('&');
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/http/utils.ts